import styles from './spacer.module.scss';

/**
 * Spacer element
 *
 * @param props - The component props object
 * @param props.type Optional - Style of spacer, 'default' | 'medium'
 * @returns Span element with spacer style css
 *
 * @example default spacer
 * ```tsx
 * <Spacer />
 * ```
 *
 * @example medium spacer
 * ```tsx
 * <Spacer type="medium" />
 * ```
 */
const Spacer = ({ type = 'default' }: { type?: 'default' | 'medium' }) => {
    return <span className={styles[type]} />;
};

export default Spacer;
